import React, { useRef, useState } from 'react';
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import {useForm} from "react-hook-form";
import {connect, useSelector} from "react-redux";
import {
    Card, CardBody, CardTitle, Col, Form, FormGroup,
    Input, Label, Row
} from 'reactstrap';
import {getStateByPath} from "../../../redux/selectors";


// components
import ServicesLangs from "./_langs";
import SelectGeneric from "../../../components/select/selectGeneric";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";

// labels
import {INTERNATIONAL} from "../../../components/i18n/i18n";
import {PH_ICON} from "../../../components/i18n/placeHolders";
import {TT_CLOSE, TT_DELETE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {FL_CATEGORY, FL_CODE, FL_COLOR, FL_ICON, FL_ORDER, FL_STATUS} from "../../../components/i18n/formLabels";

// services & providers
import {categoryProvider} from "../../../providers/categoryProvider";
import {typeServicesService} from "../../../jwt/_services/clasificator/typeServicesService";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {setForm, setItem} from "../../../redux/actions/generics/IndexedActions";
import {getCurrentDateForCodeField} from "../../../util/DateTools";


function TypeServicesForm(props) {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, udn, editMode, domainObject } = componentState?.data;

    const [status, setStatus] = useState(domainObject?.status !== undefined  ? domainObject?.status : true);
    const [langs, setLangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || []
    const [categoryId, setCategoryId] = useState( domainObject?.category?.id || null);

    const [showModalHistory, setShowModalHistory] = useState(true)
    const modalHistoryRef = useRef(null);

    const showHistory = () => {
        setShowModalHistory(true);
        modalHistoryRef.current.showModal();
    }


    const validationSchema = Yup.object().shape({});

    const {register, handleSubmit, reset } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,

            code: (domainObject?.code || `srv_` + getCurrentDateForCodeField()).toUpperCase(), // AUTOCODE
            showOrder: domainObject?.showOrder,
            icon: domainObject?.icon,
            colorHex: domainObject?.colorHex,
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            noDb : false,
            allDb : false,
            fbDataBase :  { id : app?.fbDataBase?.id },
            item : {
                ...data,
                status,
                udn: { id: udn.id },
                langs: langs
            }
        };

        if (categoryId != null)
            dataRequest.item.category = { id : categoryId };
        else
            dataRequest.item.category = null;

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, typeServicesService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, typeServicesService, dataRequest)
        }

        returnToList()
    };

    const confirmDelete = (data) => {
        return ConfirmDelete({
            path,
            remove : genericIndexedActions.delete,
            data : data,
            fbDataBaseId :  app?.fbDataBase?.id,
            service: typeServicesService
        } );
    };

    const returnToList = () => {
        reset();
        props.setItem(path, null);
        props.setForm(path, false, false, false);
        props.onClose();
    }


    return (<>
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Card className={'card-modal-medium'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <>
                        <h2 className={'card-modal-title'} > { (udn?.value || '') + ' / ' + (domainObject?.title || domainObject?.name || '') }</h2>
                        <br />
                        <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                    </>
                    <div className="top-right">
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode &&
                            <>
                                <GenericButton
                                    style={'table'}
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                                <TranslateButton item={domainObject} service={typeServicesService} />
                                <GenericButton
                                    style={'danger-secondary'}
                                    toolTip={TT_DELETE}
                                    icon={'fa-trash'}
                                    permission={'delete'}
                                    onClick={_ => confirmDelete(domainObject)}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={returnToList}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col md="2">
                            <Label>{FL_CODE}</Label>
                            <Input
                                type="text" name="code"
                                innerRef={register}
                            />
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_ICON}</Label>
                                <Input
                                    type="text"
                                    name="icon"
                                    placeholder={PH_ICON}
                                    innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_COLOR}</Label>
                                <Input
                                    type="color"
                                    name="colorHex"
                                    innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{FL_CATEGORY}</Label>
                                <SelectGeneric
                                    initialValue={categoryId}
                                    setExternalValue={value => setCategoryId(value)}
                                    provider={categoryProvider}
                                    resetValue={false}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_STATUS}</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        onChange={_ => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <div className={'form-container'}>
                        <div className={''}>
                            <h2>{INTERNATIONAL}</h2>
                        </div>
                        <div className={''}>
                            <Row>
                                <Col>
                                    <ServicesLangs
                                        langs={langs}
                                        setLangs={setLangs}
                                        translatableLangs={translatableLangs}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Form>
        {
            showModalHistory && <LogHistoryModal
                ref={modalHistoryRef}
                item={domainObject}
            />
        }
    </>)
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setItem,
    setForm,
})

export default connect(mapStateToProps, mapActionsToProps)(TypeServicesForm)